<div class="my-profile-container">
  <div class="back-item">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.97508 4.94165L2.91675 9.99998L7.97508 15.0583" stroke="white" stroke-width="1.5"
        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M17.0834 10H3.05835" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>

    <h2>
      My Profile
    </h2>
  </div>

  <div class="profile-form">
    <div class="top-elements">
      <div class="details-component">
        <div class="short-name">
          EW
        </div>
        <div>
          <h1>Elouera Wilson</h1>
          <p>Student</p>
        </div>
      </div>


      <div class="edit-button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path xmlns="http://www.w3.org/2000/svg"
            d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM10.95 17.51C10.66 17.8 10.11 18.08 9.71 18.14L7.25 18.49C7.16 18.5 7.07 18.51 6.98 18.51C6.57 18.51 6.19 18.37 5.92 18.1C5.59 17.77 5.45 17.29 5.53 16.76L5.88 14.3C5.94 13.89 6.21 13.35 6.51 13.06L10.97 8.6C11.05 8.81 11.13 9.02 11.24 9.26C11.34 9.47 11.45 9.69 11.57 9.89C11.67 10.06 11.78 10.22 11.87 10.34C11.98 10.51 12.11 10.67 12.19 10.76C12.24 10.83 12.28 10.88 12.3 10.9C12.55 11.2 12.84 11.48 13.09 11.69C13.16 11.76 13.2 11.8 13.22 11.81C13.37 11.93 13.52 12.05 13.65 12.14C13.81 12.26 13.97 12.37 14.14 12.46C14.34 12.58 14.56 12.69 14.78 12.8C15.01 12.9 15.22 12.99 15.43 13.06L10.95 17.51ZM17.37 11.09L16.45 12.02C16.39 12.08 16.31 12.11 16.23 12.11C16.2 12.11 16.16 12.11 16.14 12.1C14.11 11.52 12.49 9.9 11.91 7.87C11.88 7.76 11.91 7.64 11.99 7.57L12.92 6.64C14.44 5.12 15.89 5.15 17.38 6.64C18.14 7.4 18.51 8.13 18.51 8.89C18.5 9.61 18.13 10.33 17.37 11.09Z"
            fill="#007BFF" class="__web-inspector-hide-shortcut__" />
        </svg>
      </div>
    </div>
    <div class="border-bottom"></div>

    <h3>Personal Info </h3>

    <div class="d-grid gap-14">
      <div class="d-flex gap-4">
        <div class="form-group">
          <app-input context="Normal" class="form-item" label="First name" placeholder="Enter your first name"
            type="text" [control]="form.get('firstName')" [required]="true"
            [customErrorMessages]="customErrorMessages.firstName">
          </app-input>
        </div>

        <div class="form-group">
          <app-input context="Normal" class="form-item" label="Last name" placeholder="Enter your last name" type="text"
            [control]="form.get('lastName')" [required]="true" [customErrorMessages]="customErrorMessages.lastName">
          </app-input>
        </div>
      </div>

      <div class="d-flex gap-4">
        <div class="form-group">
          <app-input context="Normal" class="form-item" label="Date of birth" placeholder="Enter your date of birth"[dateType]="true"
            type="date" [control]="form.get('dob')" [required]="true" [customErrorMessages]="customErrorMessages.dob">
          </app-input>
        </div>
        <div class="form-group">
          <app-input context="Normal" class="form-item" label="Email (School)" placeholder="Enter your email"
            type="text" [control]="form.get('schoolEmail')" [required]="true"
            [customErrorMessages]="customErrorMessages.schoolEmail">
          </app-input>
        </div>
      </div>

      <div class="d-flex gap-4">
        <div class="form-group">
          <app-input context="Normal" class="form-item" label="Parent/Guardian full name"
            placeholder="Enter parent/guardian full name" type="text" [control]="form.get('parentName')"
            [required]="true" [customErrorMessages]="customErrorMessages.parentName">
          </app-input>
        </div>

        <div class="form-group">
          <app-input context="Normal" class="form-item" label="Parent/Guardian email"
            placeholder="Enter parent/guardian email" type="text" [control]="form.get('parentEmail')"
            [required]="true" [customErrorMessages]="customErrorMessages.parentEmail">
          </app-input>
        </div>
      </div>

      <div class="d-flex gap-4">
        <div class="form-group">
          <app-input context="Normal" class="form-item" label="Year level/Grade" placeholder="Enter your year level"
            type="number" [control]="form.get('yearLevel')" [customErrorMessages]="customErrorMessages.yearLevel">
          </app-input>
        </div>
        <div class="form-group">
          <app-input context="Normal" class="form-item" label="Gender" placeholder="Select Gender" type="select"
            [control]="form.get('gender')" [options]="genderOptions" [customErrorMessages]="customErrorMessages.gender">
          </app-input>
        </div>
      </div>

      <div class="d-flex gap-4">
        <div class="form-group">
          <app-input context="Normal" class="form-item" label="Ethnicity" placeholder="Enter ethnicity" type="text"
            [control]="form.get('ethnicity')" [customErrorMessages]="customErrorMessages.ethnicity">
          </app-input>
        </div>

        <div class="form-group">
          <app-input context="Normal" class="form-item" label="Email (Personal)" placeholder="Enter your email"
            type="email" [control]="form.get('personalEmail')"
            [customErrorMessages]="customErrorMessages.personalEmail">
          </app-input>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <button type="button" class="btn-cancel">Cancel</button>
      <button type="button" class="btn-save">Save</button>
    </div>
  </div>
</div>